let inactivityTimer;

export const getRefreshTokenExpiry = () => {
  const refreshToken = localStorage.getItem("refresh");
  if (!refreshToken) return null;
  try {
    const payload = JSON.parse(atob(refreshToken.split(".")[1]));
    return payload.exp * 1000; // Return in milliseconds
  } catch (e) {
    return null;
  }
};

export const setupInactivityTimeout = (onTimeout, timeout) => {
  const events = ['mousemove', 'keydown', 'scroll', 'click'];

  const handleTimeout = () => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) return;

    const lastActive = localStorage.getItem("session_last_activity");
    const now = Date.now();

    if (lastActive && now - parseInt(lastActive, 10) > timeout) {
      onTimeout();
    } else {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(handleTimeout, timeout);
    }
  };

  const checkAndReset = () => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) return;

    const lastActive = localStorage.getItem("session_last_activity");
    const now = Date.now();

    if (lastActive && now - parseInt(lastActive, 10) > timeout) {
      onTimeout();
      return;
    }

    localStorage.setItem("session_last_activity", now.toString());
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(handleTimeout, timeout);
  };

  const handleVisibilityOrFocus = () => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) return;

    const lastActive = localStorage.getItem("session_last_activity");
    const now = Date.now();

    if (lastActive && now - parseInt(lastActive, 10) > timeout) {
      onTimeout();
    }
  };

  // Attach event listeners
  events.forEach(event => window.addEventListener(event, checkAndReset));
  window.addEventListener('visibilitychange', handleVisibilityOrFocus);
  window.addEventListener('focus', handleVisibilityOrFocus);

  // Initialize
  const accessToken = localStorage.getItem("access");
  if (accessToken && !localStorage.getItem("session_last_activity")) {
    localStorage.setItem("session_last_activity", Date.now().toString());
  }

  clearTimeout(inactivityTimer);
  inactivityTimer = setTimeout(handleTimeout, timeout);

  return () => {
    clearTimeout(inactivityTimer);
    events.forEach(event => window.removeEventListener(event, checkAndReset));
    window.removeEventListener('visibilitychange', handleVisibilityOrFocus);
    window.removeEventListener('focus', handleVisibilityOrFocus);
  };
};

export const getServerTime = () => {
  const skew = localStorage.getItem("server_clock_skew");
  const offset = skew ? parseInt(skew, 10) : 0;
  return Date.now() + offset;
};
